var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCampanha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.491,
    height: 30.088,
    viewBox: "0 0 28.491 30.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-campanha",
    transform: "translate(-13.588 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_854",
    "data-name": "Grupo 854",
    transform: "translate(13.588 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1424",
    "data-name": "Caminho 1424",
    d: "M29.456.294a.588.588,0,0,0-1.1.31,8.57,8.57,0,0,1-2.366,6.178.588.588,0,1,0,.853.809,9.734,9.734,0,0,0,2.548-5.054l8.394,14.539a9.792,9.792,0,0,0-8.265.719l-3.929,2.269L20.708,11.6l1.639-.946a.588.588,0,0,0-.588-1.018l-5.142,2.969A6.062,6.062,0,0,0,21.73,23.548c1.023.951,4.7,4.373,6.858,6.382a.588.588,0,0,0,.694.079l3.337-1.927a.588.588,0,0,0,.107-.939L26.2,21.071l3.91-2.258a8.618,8.618,0,0,1,8.833.123.588.588,0,0,0,.817-.794Zm-14.04,20a4.892,4.892,0,0,1,1.788-6.674l2.485-1.435,4.883,8.457L21.62,22.326A4.893,4.893,0,0,1,15.417,20.3Zm13.654,8.475c-1.979-1.843-4.944-4.6-6.207-5.776l2.272-1.312,6.207,5.776Z",
    transform: "translate(-13.588 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1425",
    "data-name": "Caminho 1425",
    d: "M412.584,96.989a.587.587,0,0,0,.8.215l2.291-1.323a.588.588,0,1,0-.588-1.018L412.8,96.187A.588.588,0,0,0,412.584,96.989Z",
    transform: "translate(-389.063 -89.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1426",
    "data-name": "Caminho 1426",
    d: "M389.4,43.386a.587.587,0,0,0,.8-.215l1.264-2.19a.588.588,0,1,0-1.018-.588l-1.264,2.19A.588.588,0,0,0,389.4,43.386Z",
    transform: "translate(-367.04 -37.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1427",
    "data-name": "Caminho 1427",
    d: "M438.5,157.519h-2.529a.588.588,0,0,0,0,1.175H438.5a.588.588,0,1,0,0-1.175Z",
    transform: "translate(-410.599 -148.262)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 0.588,
    cy: 0.588,
    r: 0.588,
    transform: "translate(10.168 8.236)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCampanha);
export default __webpack_public_path__ + "static/media/menu-campanha.2dc93fe61f87886d6a5be261b9b68078.svg";
export { ForwardRef as ReactComponent };